/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 355:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(261);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_9__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }










function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var CompleteTheLook = /*#__PURE__*/function () {
  function CompleteTheLook() {
    var _this$modal, _this$modal2, _this$modal3, _this$modal4;

    _classCallCheck(this, CompleteTheLook);

    this.section = document.querySelector('.complete-the-look');
    if (!this.section) return;
    this.slider = this.section.querySelector('.js-complete-the-look-slider');
    this.modal = document.getElementById('completeTheLookModal');
    this.modalClose = (_this$modal = this.modal) === null || _this$modal === void 0 ? void 0 : _this$modal.querySelector('.complete-the-look__modal-close');
    this.modalOverlay = (_this$modal2 = this.modal) === null || _this$modal2 === void 0 ? void 0 : _this$modal2.querySelector('.complete-the-look__modal-overlay');
    this.modalAddBtn = (_this$modal3 = this.modal) === null || _this$modal3 === void 0 ? void 0 : _this$modal3.querySelector('.complete-the-look__modal-add-btn');
    this.variantOptions = (_this$modal4 = this.modal) === null || _this$modal4 === void 0 ? void 0 : _this$modal4.querySelector('.complete-the-look__variant-options');
    this.selectedProduct = null;
    this.selectedVariant = null;
    this.init();
  }

  _createClass(CompleteTheLook, [{
    key: "init",
    value: function init() {
      this.initializeSlider();
      this.bindEvents();
      this.checkCartItems();
      this.setupCartListeners();
    }
  }, {
    key: "initializeSlider",
    value: function initializeSlider() {
      if (this.slider) {
        var isDesktop = window.matchMedia('(min-width: 990px)').matches;
        new (flickity__WEBPACK_IMPORTED_MODULE_9___default())(this.slider, {
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
          setGallerySize: true,
          cellAlign: isDesktop ? 'left' : 'left',
          groupCells: isDesktop ? '80%' : false,
          watchCSS: true,
          wrapAround: false,
          contain: true,
          freeScroll: isDesktop
        });
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // Direct add to cart buttons
      this.section.addEventListener('click', function (e) {
        if (e.target.classList.contains('complete-the-look__add-btn')) {
          _this.handleDirectAddToCart(e);
        }
      }); // Size selection buttons

      this.section.addEventListener('click', function (e) {
        if (e.target.classList.contains('complete-the-look__select-btn')) {
          _this.handleSizeSelection(e);
        }
      }); // Modal events

      if (this.modalClose) {
        this.modalClose.addEventListener('click', function () {
          return _this.closeModal();
        });
      }

      if (this.modalOverlay) {
        this.modalOverlay.addEventListener('click', function () {
          return _this.closeModal();
        });
      }

      if (this.modalAddBtn) {
        this.modalAddBtn.addEventListener('click', function () {
          return _this.handleModalAddToCart();
        });
      } // Escape key to close modal


      document.addEventListener('keydown', function (e) {
        var _this$modal5;

        if (e.key === 'Escape' && (_this$modal5 = _this.modal) !== null && _this$modal5 !== void 0 && _this$modal5.classList.contains('active')) {
          _this.closeModal();
        }
      });
    }
  }, {
    key: "setupCartListeners",
    value: function setupCartListeners() {
      var _this2 = this;

      // Listen for cart updates
      document.addEventListener('cart:updated', function () {
        return _this2.checkCartItems();
      });
      document.addEventListener('cart:loaded', function () {
        return _this2.checkCartItems();
      }); // Initial cart check with delay to ensure cart is loaded

      setTimeout(function () {
        return _this2.checkCartItems();
      }, 100);
    }
  }, {
    key: "checkCartItems",
    value: function checkCartItems() {// Get cart items from various possible sources
      //   let cartItems = [];
      //   if (window.sideCart?.cart?.items) {
      //     cartItems = window.sideCart.cart.items;
      //   } else if (window.theme?.cart?.items) {
      //     cartItems = window.theme.cart.items;
      //   } else if (window.cart?.items) {
      //     cartItems = window.cart.items;
      //   }
      //   const completeTheLookProducts = this.section.querySelectorAll('[data-product-handle]');
      //   let visibleProductCount = 0;
      //   completeTheLookProducts.forEach(productCard => {
      //     const handle = productCard.dataset.productHandle;
      //     const isInCart = cartItems.some(item => 
      //       item.handle === handle || 
      //       item.product_handle === handle ||
      //       (item.url && item.url.includes(handle))
      //     );
      //     if (isInCart) {
      //       this.hideProduct(productCard);
      //     } else {
      //       productCard.style.display = '';
      //       visibleProductCount++;
      //     }
      //   });
      //   // Hide entire section if no visible products
      //   if (visibleProductCount === 0) {
      //     this.section.style.display = 'none';
      //   } else {
      //     this.section.style.display = '';
      //   }
      // }
      // hideProduct(productCard) {
      //   productCard.classList.add('fade-out');
      //   setTimeout(() => {
      //     productCard.style.display = 'none';
      //     productCard.classList.remove('fade-out');
      //     // Update slider if it exists and is initialized
      //     if (this.slider) {
      //       const flickity = Flickity.data(this.slider);
      //       if (flickity) {
      //         flickity.reloadCells();
      //         flickity.resize();
      //       }
      //     }
      //   }, 300);
    }
  }, {
    key: "handleDirectAddToCart",
    value: function () {
      var _handleDirectAddToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var _this3 = this;

        var button, variantId, productHandle, productCard;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                button = e.target;
                variantId = button.dataset.variantId;
                productHandle = button.dataset.productHandle;

                if (variantId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                // Add loading state
                button.classList.add('loading');
                button.disabled = true;
                _context.prev = 8;
                _context.next = 11;
                return this.addToCart(parseInt(variantId));

              case 11:
                // Hide the product card after successful add
                productCard = button.closest('.complete-the-look__product-card');

                if (productCard) {//this.hideProduct(productCard);
                } // Check if section should be hidden


                setTimeout(function () {
                  return _this3.checkCartItems();
                }, 100);
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](8);
                console.error('Error adding to cart:', _context.t0); // Show error message to user

                this.showErrorMessage('Failed to add product to cart. Please try again.');

              case 20:
                _context.prev = 20;
                button.classList.remove('loading');
                button.disabled = false;
                return _context.finish(20);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 16, 20, 24]]);
      }));

      function handleDirectAddToCart(_x) {
        return _handleDirectAddToCart.apply(this, arguments);
      }

      return handleDirectAddToCart;
    }()
  }, {
    key: "handleSizeSelection",
    value: function () {
      var _handleSizeSelection = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var button, productHandle, response, product;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                button = e.target;
                productHandle = button.dataset.productHandle;

                if (productHandle) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                // Add loading state
                button.classList.add('loading');
                _context2.prev = 6;
                _context2.next = 9;
                return fetch("/products/".concat(productHandle, ".js"));

              case 9:
                response = _context2.sent;
                _context2.next = 12;
                return response.json();

              case 12:
                product = _context2.sent;
                this.selectedProduct = product;
                this.showVariantModal(product);
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](6);
                console.error('Error fetching product:', _context2.t0);
                this.showErrorMessage('Failed to load product options. Please try again.');

              case 21:
                _context2.prev = 21;
                button.classList.remove('loading');
                return _context2.finish(21);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 17, 21, 24]]);
      }));

      function handleSizeSelection(_x2) {
        return _handleSizeSelection.apply(this, arguments);
      }

      return handleSizeSelection;
    }()
  }, {
    key: "showVariantModal",
    value: function showVariantModal(product) {
      var _this4 = this;

      if (!this.modal || !this.variantOptions) return; // Clear previous options

      this.variantOptions.innerHTML = '';
      this.selectedVariant = null;
      this.modalAddBtn.disabled = true; // Create variant options

      product.variants.forEach(function (variant) {
        var option = document.createElement('div');
        option.className = "complete-the-look__variant-option ".concat(variant.available ? '' : 'disabled');
        var radioId = "variant-".concat(variant.id);
        option.innerHTML = "\n        <input \n          type=\"radio\" \n          name=\"complete-the-look-variant\" \n          value=\"".concat(variant.id, "\" \n          id=\"").concat(radioId, "\"\n          class=\"complete-the-look__variant-radio\"\n          ").concat(variant.available ? '' : 'disabled', "\n        />\n        <label for=\"").concat(radioId, "\" class=\"complete-the-look__variant-label\">\n          ").concat(variant.option2, " ").concat(variant.available ? '' : '- Sold Out', "\n        </label>\n      ");
        option.addEventListener('click', function () {
          return _this4.selectVariant(variant, option);
        });

        _this4.variantOptions.appendChild(option);
      });
      this.openModal();
    }
  }, {
    key: "selectVariant",
    value: function selectVariant(variant, optionElement) {
      if (!variant.available) return;
      var radio = optionElement.querySelector('input[type="radio"]');
      radio.checked = true;
      this.selectedVariant = variant; // Update UI

      this.variantOptions.querySelectorAll('.complete-the-look__variant-option').forEach(function (opt) {
        opt.classList.remove('selected');
      });
      optionElement.classList.add('selected');
      this.modalAddBtn.disabled = false;
    }
  }, {
    key: "handleModalAddToCart",
    value: function () {
      var _handleModalAddToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this$selectedVariant,
            _this5 = this;

        var productCard;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if ((_this$selectedVariant = this.selectedVariant) !== null && _this$selectedVariant !== void 0 && _this$selectedVariant.available) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                // Add loading state
                this.modalAddBtn.classList.add('loading');
                this.modalAddBtn.disabled = true;
                _context3.prev = 4;
                _context3.next = 7;
                return this.addToCart(this.selectedVariant.id);

              case 7:
                // Hide the product card after successful add
                productCard = this.section.querySelector("[data-product-handle=\"".concat(this.selectedProduct.handle, "\"]"));

                if (productCard) {//this.hideProduct(productCard);
                }

                this.closeModal(); // Check if section should be hidden

                setTimeout(function () {
                  return _this5.checkCartItems();
                }, 100);
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](4);
                console.error('Error adding to cart:', _context3.t0);
                this.showErrorMessage('Failed to add product sfsf to cart. Please try again.');

              case 17:
                _context3.prev = 17;
                this.modalAddBtn.classList.remove('loading');
                this.modalAddBtn.disabled = false;
                return _context3.finish(17);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 13, 17, 21]]);
      }));

      function handleModalAddToCart() {
        return _handleModalAddToCart.apply(this, arguments);
      }

      return handleModalAddToCart;
    }()
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(variantId) {
        var _window$sideCart, _window$theme, _window$theme$cart, _window$theme2, _window$theme2$cart;

        var quantity,
            item,
            response,
            data,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                quantity = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 1;
                item = {
                  id: variantId,
                  quantity: quantity,
                  properties: {
                    _complete_the_look: true
                  }
                }; // Try to use existing cart functionality first

                if (!((_window$sideCart = window.sideCart) !== null && _window$sideCart !== void 0 && _window$sideCart.handleAddToCartEvent)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", window.sideCart.handleAddToCartEvent([item], true));

              case 4:
                if (!((_window$theme = window.theme) !== null && _window$theme !== void 0 && (_window$theme$cart = _window$theme.cart) !== null && _window$theme$cart !== void 0 && _window$theme$cart.addToCart)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return", window.theme.cart.addToCart(item));

              case 6:
                _context4.next = 8;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(item)
                });

              case 8:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 11;
                  break;
                }

                throw new Error("HTTP error! status: ".concat(response.status));

              case 11:
                _context4.next = 13;
                return response.json();

              case 13:
                data = _context4.sent;
                // Dispatch custom event for cart update
                document.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: data
                })); // Try to refresh cart display

                if ((_window$theme2 = window.theme) !== null && _window$theme2 !== void 0 && (_window$theme2$cart = _window$theme2.cart) !== null && _window$theme2$cart !== void 0 && _window$theme2$cart.refreshCart) {
                  window.theme.cart.refreshCart();
                }

                return _context4.abrupt("return", data);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function addToCart(_x3) {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }()
  }, {
    key: "openModal",
    value: function openModal() {
      if (!this.modal) return;
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Focus management

      var firstInput = this.modal.querySelector('input[type="radio"]:not([disabled])');

      if (firstInput) {
        firstInput.focus();
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      if (!this.modal) return;
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      this.selectedProduct = null;
      this.selectedVariant = null;
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage(message) {
      // Create and show error notification
      var notification = document.createElement('div');
      notification.className = 'complete-the-look__error-notification';
      notification.textContent = message;
      notification.style.cssText = "\n      position: fixed;\n      top: 20px;\n      right: 20px;\n      background: #d32f2f;\n      color: white;\n      padding: 1rem;\n      border-radius: 4px;\n      z-index: 10000;\n      box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n    ";
      document.body.appendChild(notification); // Remove notification after 3 seconds

      setTimeout(function () {
        notification.remove();
      }, 3000);
    }
  }]);

  return CompleteTheLook;
}();

document.addEventListener('DOMContentLoaded', function () {
  new CompleteTheLook();
});

if (typeof window !== 'undefined') {
  window.CompleteTheLook = CompleteTheLook;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkseafolly_theme"] = self["webpackChunkseafolly_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [28], () => (__webpack_require__(355)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;